export const PAYROLL_1405_CONFIG = {
  year: 1405,
  dailyMinimumWageRial: 5_541_850,
  monthlyMinimumSalaryRial: 166_255_500,
  housingAllowanceRial: 30_000_000,
  groceryAllowanceRial: 22_000_000,
  maritalAllowanceRial: 5_000_000,
  seniorityDailyRial: 166_667,
  childAllowanceMultiplier: 3,
  workerInsuranceRate: 0.07,
  monthlyTaxExemptionRial: 400_000_000,
  standardDailyHours: 7.33,
  overtimeMultiplier: 1.4,
  taxBrackets: [
    { upToRial: 400_000_000, rate: 0 },
    { upToRial: 800_000_000, rate: 0.1 },
    { upToRial: 1_200_000_000, rate: 0.15 },
    { upToRial: 1_600_000_000, rate: 0.2 },
    { upToRial: Number.POSITIVE_INFINITY, rate: 0.3 },
  ],
} as const;

